export const CONFIRMATION_STATE = {
  pending: 'PENDING',
  positive: 'POSITIVE',
  incorrectAmount: 'INCORRECT_AMOUNT',
  negative: 'NEGATIVE',
  multiplePaid: 'MULTIPLE_PAID',
  outdated: 'OUTDATED',
  outdatedPaidNotRefunded: 'OUTDATED_PAID_NOT_REFUNDED',
  outdatedPaidRefunded: 'OUTDATED_PAID_REFUNDED',
  transactionNotFound: 'TRANSACTION_NOT_FOUND',
  merchantRejected: 'MERCHANT_REJECTED',
}

/**
 * Stany potwierdzenia, w których prowizja płatnika ma prawo się pokazać.
 *
 * Kryterium jest jedno: czy pieniądze zostały pobrane (albo są w trakcie pobierania). Reszta stanów
 * to ekrany BŁĘDU - transakcja przeterminowana, odrzucona przez sklep, nieznaleziona, zwrócona -
 * i informacja o opłacie nie ma tam czego opisywać.
 *
 * ⚠️ `PENDING` jest na liście nie dla samego ekranu potwierdzenia, tylko dla ścieżek, które
 * odpytują `/confirmation` W TRAKCIE płatności i wypełniają `confirmation.data` stanem oczekiwania:
 * czekajka Visa Mobile (`VisaMobileProcess/Data.vue`) i powrót z 3DS w trybie kartowym
 * (`views/CardStatus.vue`). Zdjęcie go zabiera prowizję z panelu zamówienia na czas oczekiwania.
 *
 * Stan spoza listy (także nieznany, dołożony kiedyś po stronie API) chowa prowizję - bezpieczniej
 * nie pokazać jej na ekranie błędu, niż pokazać na ekranie, dla którego nikt tego nie przewidział.
 */
export const CONFIRMATION_STATE_WITH_FEE_LIST = [
  CONFIRMATION_STATE.positive,
  CONFIRMATION_STATE.pending,
  CONFIRMATION_STATE.incorrectAmount,
  CONFIRMATION_STATE.multiplePaid,
  CONFIRMATION_STATE.outdatedPaidNotRefunded,
]

export const COMMERCIAL_BREAK_REDIRECT_TIME = 17
export const COMMERCIAL_BREAK_REDIRECT_TIME_LONG = 120
export const CONFIRMATION_REDIRECT_TIME = 20
export const CONFIRMATION_REDIRECT_TIME_LONG = 1500

/**
 * Powrót z banku bywa szybszy niż ITN — potwierdzenie pokazuje wtedy `PENDING`, choć stan końcowy
 * przychodzi chwilę później. Ekran odpytuje `/confirmation` ponownie w tle (bez loadera), podmienia
 * szablon na stan końcowy i dopiero wtedy raportuje wynik i zamówienie (PEP-1380).
 * Limit trzyma obciążenie backendu: najwyżej `LIMIT` dodatkowych żądań na wejście na ekran.
 */
export const CONFIRMATION_PENDING_RECHECK_MS = 5000
export const CONFIRMATION_PENDING_RECHECK_LIMIT = 3
